import React, {useRef, useState} from "react";

import { Box, Button, Checkbox, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";
import {readableDate} from "../../utils";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import {useReactToPrint} from "react-to-print";
import PrintOrderForm from "./PrintOrderForm";

function OrderingInfoSection(props) {
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [, setTypeahead] = useState();
  const printOrderInfo = useRef();

  const handleOrderInfoPrint = useReactToPrint({contentRef: printOrderInfo});

  const getNewOrder = (order) => {
      // Recalcs purchase price
      if ((order.dealer_discount || order.dealer_discount === 0) && (order.manufacturer_discount || order.manufacturer_discount === 0) && order.retail_price) {
        let newPurchasePrice = (order.retail_price - ((1 * order.manufacturer_discount + 1 * order.dealer_discount) / 100) * order.retail_price)
            + 1 * (order.body_aux_price | 0) + 1 * (order.delivery_charge | 0) + 1 * (order.extra_cost | 0);

        newPurchasePrice = Math.round( (newPurchasePrice * 100) ) / 100;

        order['ordered_purchase_price'] = newPurchasePrice
      }
      return order
  }



  const onChange = e => {
      let newOrder = {...props.data};
      newOrder[e.target.name] = e.target.value;

      newOrder = getNewOrder(newOrder);

      props.onChange(newOrder, props.index);
  }

  const getColor = () => {
      if(!(!!props.data.purchase_invoice_number)){
          return "table-highlight-orange"
      }
      else{
          return ""
      }
  }

  const onDepartmentChange = e => {
      // props.departmentObjects
      const toUpdate = {
          target: {
              name: e.target.name,
              value: props.departmentObjects[e.target.value]
          }
      };
      onChange(toUpdate)
  }

  const handleSupplierSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleCustomerSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleVehicleSupplierSelect = supplier => {
    onChange({target: {name: 'vehicle_supplier', value: supplier[0]}})
  };

  const handleReserveCustomerSelect = reserve_customer => {
    onChange({target: {name: 'reserve_customer', value: reserve_customer[0]}})
  };



  const onCalcChange = e => {
    const body_aux_price = e.target.name === "body_aux_price" ? e.target.value : props.data.body_aux_price;
    const delivery_charge = e.target.name === "delivery_charge" ? e.target.value : props.data.delivery_charge;
    const extra_cost = e.target.name === "extra_cost" ? e.target.value : props.data.extra_cost;
    onChange(e);
    if ((props.data.dealer_discount || props.data.dealer_discount === 0) && (props.data.manufacturer_discount || props.data.manufacturer_discount === 0) && props.data.retail_price) {
      const newPurchasePrice = (props.data.retail_price - ((1 * props.data.dealer_discount + 1 * props.data.manufacturer_discount) / 100) * props.data.retail_price) + 1 * (body_aux_price | 0) + 1 * (delivery_charge | 0) + 1 * (extra_cost | 0)  ;
      onChange({target: {name: 'ordered_purchase_price', value: newPurchasePrice}})
    }

  };

  const handleCheckbox = e => {
    const {name, checked} = e.target;
    onChange({target: {name, value: checked}});
  };

  const generateOrderNumber = () => {
      const conf = {
          url: props.endpoint+"vehicles/generateordernumber",
          method:"get"
      }
      axios(conf).then(resp => {
          const toUpdate = {
              target: {
                  name: "order_number",
                  value: resp.data['order_number']
              }
          }
          onChange(toUpdate);
      })
  }

  return (
    <Box>
      <details>
        <summary><Title className={`title ${getColor()}`}>{`Ordering Info - ${props.data.department ? props.data.department.name : ""} - ${props.data.ordered_date ? readableDate(props.data.ordered_date) : ""}`}</Title></summary>
      <div>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Retail Price (*)</label>
              <Control>
                <Input
                  type="number"
                  name="retail_price"
                  onChange={onChange}
                  value={props.data.retail_price}
                />
              </Control>
            </Field>
          </Column>

          <Column>
            <Field>
              <label className="label">Dealer Discount (%) (*)</label>
              <Control>
                <Input
                  type="number"
                  name="dealer_discount"
                  onChange={onChange}
                  value={props.data.dealer_discount}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Manufacturer Discount (%)</label>
              <Control>
                <Input
                  type="number"
                  name="manufacturer_discount"
                  onChange={onChange}
                  value={props.data.manufacturer_discount}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Body/Auxiliaries Price</label>
              <Control>
                <Input
                  type="text"
                  name="body_aux_price"
                  onChange={onChange}
                  value={props.data.body_aux_price}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Delivery Charge</label>
              <Control>
                <Input
                  type="number"
                  name="delivery_charge"
                  onChange={onChange}
                  value={props.data.delivery_charge}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Extra Costs</label>
              <Control>
                <Input
                  type="text"
                  name="extra_cost"
                  onChange={onChange}
                  value={props.data.extra_cost}
                />
              </Control>
            </Field>
          </Column>
            <Column>
            <Field>
              <label className="label">Purchase Price (*)</label>
              <Control>
                <Input
                  type="text"
                  name="ordered_purchase_price"
                  onChange={onChange}
                  value={props.data.ordered_purchase_price}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <Control>
                <label className="label">Ordered Date (*)</label>
                <Input
                  type="date"
                  name="ordered_date"
                  onChange={onChange}
                  value={String(props.data.ordered_date)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <label className="label">Order Number (*)</label>
            <Field className={"has-addons"}>
              <Control>
                <Input
                  type="text"
                  name="order_number"
                  onChange={onChange}
                  value={props.data.order_number}
                />
              </Control>
              <Control>
              <Button
                color={"success"}
                onClick={generateOrderNumber}
              >
                  Generate
              </Button>
            </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Deposit to be paid</label>
              <Control>
                <Input
                  type="text"
                  name="deposit_to_be_paid"
                  onChange={onChange}
                  value={props.data.deposit_to_be_paid}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Deposit Allocated Date</label>
                <Input
                  type="date"
                  name="deposit_allocated_date"
                  onChange={onChange}
                  value={String(props.data.deposit_allocated_date)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Month Due (*)</label>
                <Input
                  type="month"
                  name="month_due"
                  onChange={onChange}
                  value={String(props.data.month_due)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Delivery Date</label>
                <Input
                  type="date"
                  name="delivery_date"
                  onChange={onChange}
                  value={String(props.data.delivery_date)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Delivery Confirmed</label>
                <Checkbox
                  type="checkbox"
                  name="delivery_date_confirmed"
                  onChange={handleCheckbox}
                  checked={props.data.delivery_date_confirmed}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Spec</label>
              <Control>
                <Input
                  type="text"
                  name="spec"
                  onChange={onChange}
                  value={props.data.spec}
                />
              </Control>
            </Field>
          </Column>
          {/*<Columns.Column>*/}
          {/*  <Form.Field>*/}
          {/*    <Form.Label>Customer Reservation</Form.Label>*/}
          {/*    <Form.Control>*/}
          {/*      <Form.Input*/}
          {/*        type="text"*/}
          {/*        name="customer_reservation"*/}
          {/*        onChange={props.onChange}*/}
          {/*        value={props.data.customer_reservation}*/}
          {/*      />*/}
          {/*    </Form.Control>*/}
          {/*  </Form.Field>*/}
          {/*</Columns.Column>*/}

        </Columns>
        <Columns isMultiline>
          <Column>
                <DepartmentSelector
                    options={props.departments}
                    value={props.data.department}
                    label={"New Department Owner (*)"}
                    blank={true}
                    onChange={onDepartmentChange}
                    disabled={false}
                    name={"department"}
                />
          </Column>
          <Column>
            <Field>
              <label className="label">Supplier (*)</label>
              <Control>
                <AsyncTypeahead
                  useCache={false}
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"vehicle_supplier"}
                  onSearch={handleSupplierSearch}
                  onChange={handleVehicleSupplierSelect}
                  placeholder={"Search Supplier"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                  selected={props.data.vehicle_supplier && props.data.vehicle_supplier.id ? [props.data.vehicle_supplier] : []}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Reserve Customer</label>
              <Control>
                <AsyncTypeahead
                  useCache={false}
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"reserve_customer"}
                  onSearch={handleCustomerSearch}
                  onChange={handleReserveCustomerSelect}
                  placeholder={"Search Customer"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                  selected={props.data.reserve_customer && props.data.reserve_customer.id ? [props.data.reserve_customer] : []}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Invoice Number</label>
              <Control>
                <Input
                  type="text"
                  name="purchase_invoice_number"
                  onChange={onChange}
                  value={props.data.purchase_invoice_number}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">DEPR</label>
              <Control>
                <Input
                  type="text"
                  name="depr"
                  onChange={onChange}
                  value={props.data.depr}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Status</label>
              <Control>
                <Input
                  type="text"
                  name="status"
                  onChange={onChange}
                  value={props.data.status}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Exchange Vehicle</label>
              <Control>
                <Input
                  type="text"
                  name="exchange_vehicle"
                  onChange={onChange}
                  value={props.data.exchange_vehicle}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Extras</label>
              <Control>
                <Input
                  type="text"
                  name="extras"
                  onChange={onChange}
                  value={props.data.extras}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Comments</label>
              <Control>
                <Input
                  type="text"
                  name="ordering_comments"
                  onChange={onChange}
                  value={props.data.ordering_comments}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
            <Column>
                <Button
                    color={"danger"}
                    onClick={e => props.removeOrder(props.index)}
                >
                    Remove Order
                </Button>
            </Column>
            <Column>
                <Control className={"has-addons"}>
                      <Field>
                          <Button color="warning" onClick={handleOrderInfoPrint}>
                             Print Order Form
                          </Button>
                      </Field>
                </Control>
            </Column>
        </Columns>
        <div style={{display: "none"}}>
          <div>
            <PrintOrderForm ref={printOrderInfo} order={props.data} vehicle={props.vehicle}/>
          </div>
        </div>
      </div>
      </details>
    </Box>
  );
}

export default OrderingInfoSection;
